import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { timelineActions } from './timeline.actions';
import { delay, exhaustMap, map } from 'rxjs';
import { LoadingState } from '../models/loader.model';
import { mapResponse } from '@ngrx/operators';

// export const timelineLoadEffect = createEffect(
//   (actions$ = inject(Actions), timelineService = inject(YourService)) =>
//     actions$.pipe(
//       ofType(timelineActions.load),
//       exhaustMap((props) =>
//         timelineService.yourControllerGetTimeline(props).pipe(
//           delay(1000),
//           mapResponse({
//             next: (r) =>
//               timelineActions.done({
//                 data: r.data,
//                 state: { value: LoadingState.SUCCESS },
//               }),
//               error: (error: ZetraError) =>
//               timelineActions.done({
//                 state: {
//                   value: LoadingState.FAIL,
//                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
//                 },
//               }),
//           }),
//         ),
//       ),
//     ),
//   { functional: true },
// );

// effetto mock
export const timelineLoadEffect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(timelineActions.load),
      map(() => {
        const mockData: any[] = [
          {
            status: 'success',
            color: 'success-bg',
            user: {
              firstName: 'Mario',
              lastName: 'Rossi',
              userName: 'mrossi',
            },
            notes: 'Pratica creata correttamente',
            date: new Date().toISOString(),
          },
          {
            status: 'processing',
            color: 'warning-bg',
            user: {
              firstName: 'Luigi',
              lastName: 'Bianchi',
              userName: 'lbianchi',
            },
            notes: 'Documento in fase di verifica',
            date: new Date().toISOString(),
          },
          {
            status: 'neutral',
            color: 'neutral-bg',
            user: {
              firstName: 'Anna',
              lastName: 'Verdi',
              userName: 'averdi',
            },
            notes: 'In attesa di approvazione',
            date: new Date().toISOString(),
          },
        ];

        return timelineActions.done({
          data: {
            list: mockData,
          },
          state: { value: LoadingState.SUCCESS },
        });
      }),
      delay(500),
    );
  },
  { functional: true },
);
